/*
 * @Descripttion:
 * @version:
 * @Author: banxia
 * @Date: 2022-11-24 17:13:37
 * @LastEditors: banxia
 * @LastEditTime: 2022-11-25 09:17:36
 */
import request from '@api/request'

// 通知列表
export const getListPage = params =>
  request.get('/entInformNotice/getListPage', { params })

// 通知详情
export const getDetailById = params =>
  request.get('/entInformNotice/getDetailById', { params })

// 分享公告（积分）
export const getShareDetail = params =>
  request.get('/entInformNotice/getShareDetail', { params })

// 查看公告（积分）

export const getDetail = params =>
  request.get('/entInformNotice/getDetail', { params })
